var ShapeDialogView = require('../shapeWithDialog'),
    ShapeView = require('../shape'),
    $ = require('jquery'),
    _ = require('underscore'),
    fvChannel = require('glRadio').channel('FV'),
    RedactionCodesView = require('./codeLetters.js'),
    RedactionShapeButton = require('../selectSet/btn/redactionCodeBtn'),
    RedactionPropertiesDialog = require('./dialog/redactionProperties');


var POLY_DIALOG_FADE_OUT_DURATION = 200;


module.exports = ShapeDialogView.extend({

    DialogView: RedactionPropertiesDialog,

    CodeLettersView: RedactionCodesView,

    initialize: function(options) {

        // First store reference of the 'selectedCodes'
        // Perhaps just get from the shape -- for now realize it's a direct reference
        this.selectedCodes = options.shapeModel.getReasonCodeCollection();

        // init the properties dialog -- it will be rendered when the edit button is clicked
        ShapeDialogView.prototype.initialize.call(this, _.extend(options, {
            dialogConstructor: this.DialogView,
            dialogOptions: {
                shapeModel: options.shapeModel
            },
            dialogBtnConstructor: RedactionShapeButton
        }));

        //TODO: really only wanted for poly redaction shapes -- break poly and rect apart
        this.listenTo(this.shapeUI, 'change:isParentNoteDrawing', this.prtNoteDrawingToggled);

    },

    // create and render the code letters view even if there aren't any selected codes
    // so they are printed from existing shapes
    onAfterRender: function() {

        this.codeLettersView = new this.CodeLettersView({
            parent: this,
            shape: this.options.shapeModel,
            selectedCodes: this.selectedCodes
        }).render();

    },
    //TODO: on base shape trigger onMove / onAfterMove ...  poly should be diff shape type and overload ...
    shapeSubs: _.extend( {}, ShapeDialogView.prototype.shapeSubs, {
        'shape.poly.resizeStart':       'resizePolyStart',
        'shape.resizePolyEnd':          'resizePolyEnd',
        'shape.poly.resize':            'resizePoly',
        'shapeWithDialog:beforeOpen':   'onDialogOpen',
        'shapeWithDialog:beforeClose':  'onDialogClose'
    }),

    resizePolyStart: function() {
        /*
        * '#0F3CFF': the icon mosue over color.
        * May want a derivative of the actual shape color now that not necessarily red
        * */
        this.el.animate( {stroke: '#0F3CFF'}, POLY_DIALOG_FADE_OUT_DURATION );

        this.trigger( 'shape.toggleFadeDialog', 'Out', POLY_DIALOG_FADE_OUT_DURATION );

        /*
        * DVBC-1596 -- must trigger below event separately b/c it acts on the presense of the argument
        * and 'Out' is invalid.  (It wants the bounding box of the shape or nothing).
        * */
        this.trigger('shape.redaction.poly.resize');

    },
    resizePoly: function() {
        this.trigger('shape.redaction.poly.resize');
    },
    resizePolyEnd: function() {

        this.el.animate( {
            stroke: this.getColorToApply()
        }, POLY_DIALOG_FADE_OUT_DURATION );

        this.trigger('shape.toggleFadeDialog', 'In', POLY_DIALOG_FADE_OUT_DURATION);

        /*
        * Reposition the code letters, its not done during the actual resize like with rectangles,
        * or update the connection for floating codes.
        * */
        this.trigger('shape.redaction.poly.resizeEnd');

    },
    prtNoteDrawingToggled: function(uiModel, noteIsDrawing) { //(really only wanted for poly redactions)
        this[(noteIsDrawing ? '_disable' : '_enable') + 'Select']();
        this.$el.attr('cursor', noteIsDrawing ? 'crosshair' : 'pointer');
    },
    toggleActive: function() {

        ShapeDialogView.prototype.toggleActive.apply( this, arguments );
        // Set the svg attributes for the code letters ( the shape is handled first in the base class ).
        this.trigger('codeLetters.updateStyleAndPosition');

    },
    /*
    * Hack!!! -- calling toggleExpanded the base ShapeView, not ShapeDialogView.
    * This is because ShapeDialogView.toggleExpanded calls the overwritten function in the GraphicShapeView
    * ( see signature.js )
    *  Rather than fix that now and deal with any fallout, use this quick fix for now.
    * */
    toggleExpanded: function() {

        ShapeView.prototype.toggleExpanded.apply( this, arguments );

        // TODO -- perhaps a generic layer fn for compound shapes like this that is called whenever they are moved front/back
        this.trigger('codeLetters.updateStyleAndPosition');

    },

    noteConsultGroupChange: function() {

        ShapeView.prototype.noteConsultGroupChange.apply( this, arguments );
        this.trigger('codeLetters.updateStyleAndPosition');

    },

    onDialogOpen: function() {

        this.shapeModel.setSelectedCodeAndFillOnDialogOpen();

    },

    /*
     * Only update the reason codes in local storage if they changed from open to close of the dialog
     * ( don't have it automatically set on exit ).
     * Prevents case of updating local storage when the user made no changes to the codes.
     * This mimics functionality in the fat client, where the dialog is a 'save' dialog, and local storage
     * is only updated if the user explicitly chooses to 'save changes'.
     * */
    onDialogClose: function() {

        this.shapeModel.updateLocalStoragePostDialogClose( 0 );

    },

    onBeforeDestroy: function() {

        // (former predicate for spider redactions, which may have not code view )
        this.codeLettersView && this.codeLettersView.destroy();

        ShapeDialogView.prototype.onBeforeDestroy.apply( this, arguments );

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/redaction/redactionShape.js
 ** module id = 233
 ** module chunks = 0
 **/